<template>
  <div class="-slider-box -hue-slider">
    <span>Hue</span>
    <div
      class="-slider"
      ref="slider"
      @mousedown="
        mouseDown($event);
        clickOnSlider($event);
      "
      :style="[backgroundReflection]"
    >
      <div
        class="-handle"
        ref="handle"
        :style="{
          left: sliderPosition - 2 + '%',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import sliderMixin from '../mixins/slider.vue';

export default {
  mixins: [sliderMixin],

  props: {
    hsl: {
      type: Object,
      required: true,
    },

    standalone: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    backgroundReflection() {
      const iterations = 360 / 10;
      let result = '-webkit-linear-gradient(left, ';
      const s = this.standalone;

      for (let i = 0; i < iterations; i++) {
        result += `hsla(${i * 10},${s ? 100 : this.hsl.s * 100}%,${
          s ? 50 : this.hsl.l * 100
        }%,1)`;
        result += i + 1 === iterations ? '' : ',';
      }

      return {
        // apparently, chrome is converting any format (hsla, hex and etc)
        // to rgb/a, if it is defined by js in style
        // example: https://jsfiddle.net/Herteby/2y9b5qLx/2/
        background: result + ')',
      };
    },

    sliderPosition() {
      const divider = 360 / this.hsl.h;
      return _.constrain(0, app.sfp(100 / divider, 1e2), 100);
    },
  },

  methods: {
    getSliderNewPosition(e) {
      const slider = this.$refs.slider;
      const sliderRect = slider.getBoundingClientRect();
      const difference = e.clientX - sliderRect.left;
      const divider = sliderRect.width / difference;
      return _.constrain(0, app.sfp(360 / divider, 1e2), 360);
    },

    clickOnSlider(e) {
      const handle = this.$refs.handle;
      const isClickedHandle = handle.contains(e.target);

      // clicked on slider, and not on handle
      if (!isClickedHandle) {
        this.setNewHsl(e);
      }
    },

    setNewHsl(e) {
      const newPosition = this.getSliderNewPosition(e);
      this.$emit('update-hsl', { h: newPosition });
    },

    onMouseMove(e) {
      this.setNewHsl(e);
    },
  },
};
</script>
